import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteIdentify,
  getIdentifyById,
  // getIdentifyErrors,
} from "../store/identify";
import { addOneDay } from "../utils/dateFormat";
import IdentityLoader from "../components/hoc/identityLoader";
import CafesLoader from "../components/hoc/cafesLoader";
import { getCafeById } from "../store/cafes";
import { useI18n } from "../i18n/LanguageContext";

const CollectionPoin = ({ groupId }) => {
  const dispatch = useDispatch();
  const { t } = useI18n();

  const identify = useSelector(getIdentifyById(groupId));
  const cafe = useSelector(getCafeById(identify?.cafe));

  // const error = useSelector(getIdentifyErrors());

  const handleClick = () => {
    dispatch(deleteIdentify({ groupId: groupId }));
  };

  const updatedAt = identify && new Date(identify.updatedAt); // твое поле из БД
  const expireAt =
    updatedAt && new Date(updatedAt.getTime() + 2 * 24 * 60 * 60 * 1000);
  const timeNow = new Date();
  return (
    <IdentityLoader>
      <CafesLoader>
        {identify && (
          <div className=" bg-white p-5 rounded-sm shadow-md">
            <div className="flex flex-col">
              <div className="flex justify-center py-5 font-bold text-lg sm:text-xl">
                {t("meet.title")}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm sm:text-base">
                <div className="p-3 border rounded-md bg-gray-50 text-center">
                  <span className="font-semibold">{t("meet.cafe")}</span> {cafe?.name}
                </div>
                <div className="p-3 border rounded-md bg-gray-50 text-center">
                  <span className="font-semibold">{t("meet.address")}</span> {cafe?.address}
                </div>
                <div className="p-3 border rounded-md bg-gray-50 text-center">
                  <span className="font-semibold">{t("meet.datetime")}</span>{" "}
                  {addOneDay(identify?.updatedAt) +
                    " " +
                    t("meet.time") +
                    " " +
                    identify?.time}
                </div>
                <div className="p-3 border rounded-md bg-gray-50 text-center">
                  <span className="font-semibold">{t("meet.sign")}</span>{" "}
                  {identify?.identify}
                </div>
              </div>
              <div className="flex justify-center mt-5">
                {identify?.love ? (
                  <div className="p-4 bg-green-200 rounded-md">
                    {t("meet.couple")}
                  </div>
                ) : (
                  <div className="p-4 bg-slate-400">{t("meet.three")}</div>
                )}
              </div>
              {expireAt < timeNow && (
                <div className="flex justify-center pt-10">
                  <button
                    className="bg-lime-300 text-black hover:bg-lime-500 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={handleClick}
                  >
                    {t("meet.button")}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </CafesLoader>
    </IdentityLoader>
  );
};

CollectionPoin.propTypes = {};

export default CollectionPoin;
